import { render } from "./BrandWienerin.vue?vue&type=template&id=eb444d04"
import script from "./BrandWienerin.vue?vue&type=script&lang=ts"
export * from "./BrandWienerin.vue?vue&type=script&lang=ts"

import "./BrandWienerin.vue?vue&type=style&index=0&id=eb444d04&lang=scss"
script.render = render

export default script